'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import BasicInterstitial from './BasicInterstitial';

const LessonCompleteInterstitial = () => /*#__PURE__*/_jsx(BasicInterstitial, {
  buttonI18n: "learningCenter.heading.backToLessons.link",
  buttonLink: "/lessons",
  headingI18n: "learningCenter.lessonInterstitials.lessonComplete",
  illustrationName: "success-green",
  subheadingI18n: "learningCenter.lessonInterstitials.keepUpTheGoodWork",
  use: "success"
});

export default LessonCompleteInterstitial;